document.addEventListener('DOMContentLoaded', () => {
  updateCartCount();

  document.addEventListener('submit', async function (e) {
    const form = e.target.closest('.sf-product-form, .sf-card-form');
    if (!form) return;

    e.preventDefault();
    e.stopPropagation();

    const formData = new FormData(form);

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' }
      });

      if (!response.ok) throw new Error('No se pudo agregar');

      await updateCartCount();
      await renderCartDrawer();
      openCartDrawer();

    } catch (error) {
      console.error(error);
      alert('No se pudo agregar al carrito.');
    }
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('.sf-cart-drawer-close') || e.target.closest('.sf-cart-drawer-overlay')) {
      closeCartDrawer();
    }
  });
  document.addEventListener('click', async function(e) {
  const button = e.target.closest('.sf-drawer-reco-add');
  if (!button) return;

  e.preventDefault();

  const variantId = button.dataset.variantId;

  if (!variantId) return;

  button.disabled = true;
  button.textContent = 'Agregando...';

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1
      })
    });

    if (!response.ok) throw new Error('No se pudo agregar');

    await updateCartCount();
    await renderCartDrawer();

    button.textContent = 'Agregado ✓';

    setTimeout(() => {
      button.textContent = 'Agregar';
      button.disabled = false;
    }, 900);

  } catch (error) {
    console.error(error);
    button.textContent = 'Error';
    button.disabled = false;
  }
});
});

function openCartDrawer() {
  const drawer = document.querySelector('#sf-cart-drawer');
  if (!drawer) return;
  drawer.classList.add('active');
}

function closeCartDrawer() {
  const drawer = document.querySelector('#sf-cart-drawer');
  if (!drawer) return;
  drawer.classList.remove('active');
}

async function updateCartCount() {
  const res = await fetch('/cart.js');
  const cart = await res.json();

  document.querySelectorAll('[data-sf-cart-count]').forEach(el => {
    el.textContent = cart.item_count;
    el.dataset.count = cart.item_count;
  });
}

async function renderCartDrawer() {
  const itemsContainer = document.querySelector('[data-sf-cart-items]');
  const totalBtn = document.querySelector('[data-sf-cart-total]');
  if (!itemsContainer) return;

  const res = await fetch('/cart.js');
  const cart = await res.json();

  itemsContainer.innerHTML = cart.items.map((item, index) => `
    <div class="sf-drawer-item">
      <img src="${item.image || ''}" alt="${escapeHtml(item.product_title)}">

      <div class="sf-drawer-item-info">
        <strong>${escapeHtml(item.product_title)}</strong>
        <span>${formatMoney(item.final_price)}</span>

        <div class="sf-drawer-qty">
          <button type="button" class="sf-qty-btn" onclick="changeCartQty(${index}, ${item.quantity - 1})">−</button>
          <span>${item.quantity}</span>
          <button type="button" class="sf-qty-btn" onclick="changeCartQty(${index}, ${item.quantity + 1})">+</button>
        </div>
      </div>

      <button type="button" class="sf-remove-item" onclick="removeCartItem(${index})">×</button>
    </div>
  `).join('');

  if (totalBtn) {
    totalBtn.textContent = formatMoney(cart.total_price);
  }
}

async function changeCartQty(index, quantity) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      line: index + 1,
      quantity: Math.max(0, quantity)
    })
  });

  await updateCartCount();
  await renderCartDrawer();
}

async function removeCartItem(index) {
  await changeCartQty(index, 0);
}

function formatMoney(cents) {
  return new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    maximumFractionDigits: 0
  }).format(cents / 100);
}

function escapeHtml(text) {
  return String(text)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
}